import { CanvasEditionService } from './canvas-edition.service';

export default angular
  .module('sfMobile.services.canvas-edition', [])
  .service('canvasEditionService', CanvasEditionService).name;
